import { css } from 'styled-components';

export const whiteCSS = css`
  background-color: var(--white);
`;

export const transparentCSS = css`
  background-color: transparent;
  padding: 0px;
`;

export const springAndTransparentCSS = css`
  background-color: var(--gallery);
  padding: 0px !important;
`;


export const springAndRedCSS = css`
  background-color: var(--red);
  padding: 0px !important;
`;
